<script>
// https://github.com/uct8086/vue-virtual-list/tree/master

// https://github.com/reactjser/vue3-virtual-scroll-list/blob/main/src/virtual-list.tsx
// missing page mode - heres how to do

import { defineComponent, watch, onActivated, onMounted, ref, computed } from 'vue'
import Virtual from '@/components/vue3/VirtualList/virtual'
import VirtualListItemDynamicSize from '@/components/vue3/VirtualList/VirtualListItemDynamicSize'
import VirtualProps from '@/components/vue3/VirtualList/props'

export default defineComponent({
  name: 'VirtualList',
  components: {
    VirtualListItemDynamicSize,
  },
  props: VirtualProps,
  emits: ['scroll', 'visible'],
  setup(props, { emit, slots }) {
    const isHorizontal = props.direction === 'horizontal'
    const directionKey = isHorizontal ? 'scrollLeft' : 'scrollTop'
    const clientSizeKey = isHorizontal ? 'clientWidth' : 'clientHeight'
    const scrollKey = isHorizontal ? 'scrollWidth' : 'scrollHeight'

    const rootRef = ref()
    const shepherdRef = ref()
    const rangeRef = ref(Object.create(null))

    let virtual = null

    const getUniqueIdFromitems = () => props.items.map(item => item[props.idKey])

    const saveSizes = () => {
      if (!props.hasDynamicSize) {
        props.items.forEach(item => {
          virtual.saveSize(item[props.idKey], props.itemSize)
        })
      }
    }

    const installVirtual = () => {
      virtual = new Virtual(
        {
          slotHeaderSize: 0,
          slotFooterSize: 0,
          keeps: props.keeps,
          estimateSize: props.estimateSize,
          buffer: Math.round(props.keeps / 3), // recommend for a third of keeps
          uniqueIds: getUniqueIdFromitems(),
        },
        range => {
          rangeRef.value = range
        },
      )
      saveSizes()
      // sync initial range
      rangeRef.value = virtual.getRange()
    }

    installVirtual()

    // get item size by id
    const getSize = id => virtual.sizes.get(id)

    // get the total number of stored (rendered) items
    const getSizes = () => virtual.sizes.size

    // set current scroll position to a expectant offset
    const scrollToOffset = offset => {
      const root = rootRef.value
      if (root) {
        if (isHorizontal) {
          root.scroll({ left: offset, behavior: props.scrollBehavior })
          return
        }
        root.scroll({ top: offset, behavior: props.scrollBehavior })
      }
    }

    // set current scroll position to bottom
    const scrollToBottom = () => {
      scrollToOffset(999999999999999 * 999999999999999)
    }

    // set current scroll position to a expectant index
    const scrollToIndex = index => {
      // scroll to bottom
      if (index >= props.items.length - 1) {
        scrollToBottom()
      } else {
        const offset = virtual.getOffset(index)
        scrollToOffset(offset)
      }
    }

    // reset all state back to initial
    const reset = () => {
      virtual.destroy()
      scrollToOffset(0)
      installVirtual()
    }

    // event called when each item mounted or size changed
    const onItemResized = ({ item, el }) => {
      const shapeKey = isHorizontal ? 'offsetWidth' : 'offsetHeight'
      const size = el[shapeKey] || 0
      const id = item[props.idKey]

      // console.log('onItemResized', item, el, size, id)
      virtual.saveSize(id, size)
    }

    // emit event in special position
    const emitEvent = (offset, clientSize, scrollSize, evt) => {
      emit('scroll', evt, virtual.getRange())
      // emit('scroll', evt, virtual.getRange())

      // if (virtual.isFront() && !!props.items.length && offset - props.topThreshold <= 0) {
      //   emit('totop')
      // } else if (virtual.isBehind() && offset + clientSize + props.bottomThreshold >= scrollSize) {
      //   emit('tobottom')
      // }
    }

    // const onScroll = throttle(e => {
    const onScroll = e => {
      const offset = e.target[directionKey]
      const clientSize = e.target[clientSizeKey]
      const scrollSize = e.target[scrollKey]

      // iOS scroll-spring-back behavior will make direction mistake
      if (offset < 0 || offset + clientSize > scrollSize + 1 || !scrollSize) {
        return
      }

      // console.log('onScroll', offset, clientSize, scrollSize, e)
      virtual.handleScroll(offset)
      emitEvent(offset, clientSize, scrollSize, e)
    }
    // }, 5)

    const visibleItems = computed(() => {
      const { start, end } = rangeRef.value
      return props.items.slice(start, end + 1)
    })

    const fullHeight = computed(() =>
      // if (!props.hasDynamicSize) {
      //   return props.itemSize * props.items.length

      // }

      // console.log(props.itemSize * props.items.length, props.items.length, props.itemSize)

      // const { padBehind } = rangeRef.value
      // if (padBehind !== 0) {
      //   return  virtual.getEstimateSize() * props.items.length
      // }
      virtual.getTotalSize(),
    )

    const rootStyle = computed(() => {
      if (isHorizontal) {
        return {
          position: 'relative',
          width: `${fullHeight.value}px`,
          // 'max-width': `${fullHeight.value}px`,
          // 'flex-shrink': 0,
        }
      }
      return {
        position: 'relative',
        height: `${fullHeight.value}px`,
        // 'flex-shrink': 0,
      }
    })

    const verticalStyle = computed(() => ({
      // position: 'absolute',
      // top: `${rangeRef.value.padFront}px`,
      'padding-top': `${rangeRef.value.padFront}px`,
      'padding-bottom': `${rangeRef.value.padBehind}px`,
    }))
    const horizontalStyle = computed(() => ({
      // position: 'relative',
      'padding-left': `${rangeRef.value.padFront}px`,
      'padding-right': `${rangeRef.value.padBehind}px`,
    }))

    watch(
      () => props.items,
      () => {
        virtual.updateParam('uniqueIds', getUniqueIdFromitems())
        virtual.handleitemsChange()
        saveSizes()
      },
    )

    watch(
      () => props.keeps,
      newValue => {
        virtual.updateParam('keeps', newValue)
        virtual.handleSlotSizeChange()
      },
    )

    watch(
      () => props.start,
      newValue => {
        scrollToIndex(newValue)
      },
    )

    watch(
      () => props.offset,
      newValue => {
        scrollToOffset(newValue)
      },
    )

    // set back offset when awake from keep-alive
    onActivated(() => {
      scrollToOffset(virtual.offset)
    })

    onMounted(() => {
      // set position
      if (props.start) {
        scrollToIndex(props.start)
      } else if (props.offset) {
        scrollToOffset(props.offset)
      }
      emit('visible')
    })

    return {
      reset,
      scrollToBottom,
      scrollToIndex,
      scrollToOffset,
      getSize,
      getSizes,
      onScroll,
      onItemResized,
      fullHeight,
      visibleItems,
      isHorizontal,
      rootRef,
      shepherdRef,
      rangeRef,
      verticalStyle,
      horizontalStyle,
      rootStyle,
    }
  },
})
</script>

<template>
  <div
    ref="rootRef"
    class="virtual-list"
    :class="`virtual-list_${direction}`"
    @scroll="onScroll"
  >
    <!-- :style="rootStyle" -->
    <div
      class="virtual-list_root"
      data-tst="root"
    >
      <slot name="before"></slot>
      <div
        v-if="hasDynamicSize"
        :style="isHorizontal ? horizontalStyle : verticalStyle"
        data-tst="group"
        class="virtual-list_group"
      >
        <!-- :key="index" -->
        <VirtualListItemDynamicSize
          v-for="(item, index) in visibleItems"
          :key="index"
          @resized="el => onItemResized({ item, el })"
        >
          <slot
            name="item"
            :item="item"
            :index="rangeRef.start + index"
          />
        </VirtualListItemDynamicSize>
      </div>

      <div
        v-else
        data-tst="group"
        :style="isHorizontal ? horizontalStyle : verticalStyle"
        class="virtual-list_group"
      >
        <template
          v-for="(item, index) in visibleItems"
          :key="index"
        >
          <slot
            name="item"
            :item="item"
            :index="rangeRef.start + index"
          />
        </template>
      </div>
    </div>

    <slot name="after"></slot>
  </div>
</template>

<style lang="scss" scoped>
.virtual-list {
  --horizontal-gap: 1px;
  &_root {
    flex-shrink: 0;
    min-width: fit-content;
  }
  &_group {
    min-width: 100%;
  }
  &_vertical {
    overflow-x: auto;
    overflow-y: auto;
  }
  &_horizontal {
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
    flex: 1;
    .virtual-list_group {
      flex: 1;
      height: 100%;
      display: flex;
      gap: var(--horizontal-gap);
    }
  }
}
</style>
